import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Modal, Tab, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { CstmPagination } from "../../../../components/Common/Common";
import GetAssignDriver from "../../GetAssignDriver";

// img
import user from "../../../../Assets/images/user.png";
import { toast } from "react-toastify";
import {
  GET_BOOKING_REQUESTS,
  GET_MY_BOOKINGS_REQUESTS,
} from "../../../../services/ApiCalls";
import Table from "../../../../components/Common/Table";
import CustomPagination from "../../../../components/Common/CustomPagination";
import TableProfile from "../../../../components/Common/TableProfile";
import { useParams } from "react-router-dom";

const MyBookings = () => {
  const [showModal, setShowModal] = useState(false);
  const { id } = useParams();
  const [tab, setTab] = useState("normal");

  const [body, setBody] = useState({
    page: 1,
    limit: 10,
    orderBy: "createdAt",
    order: -1,
    search: "",
    status: "all",
    bookingTypeRequest: 'normal'
  });

  const [loader, setLoader] = useState();

  const [data, setData] = useState([]);

  const updateData = (newData) => {
    setData(newData);
  };

  // const bookid = data.map((item, index) => ({
  //   index,
  //   _id: item._id,
  // }));
  // console.log(bookid)

  const [totalCount, setTotalCount] = useState(0);
  const [selectedBookingId, setSelectedBookingId] = useState(null);

  const handleAssignDriver = (argId) => {
    setSelectedBookingId(argId);
    setShowModal(true);
  };
  const handleClose = () => {
    setShowModal(false);
  };


  const getData = async (body) => {
    setLoader(true);
    try {
      const res = await GET_MY_BOOKINGS_REQUESTS(body);
      console.log(res, "chkres");
      if (res?.data?.status === "success") {
        setData(res?.data?.data);
        // console.log(data, "sddsdsd");
        setLoader(false);

        setTotalCount(res?.data?.totalcount);
      } else {
        setLoader(false);

        toast.error(res?.data?.message);
      }
    } catch (error) {
      setLoader(false);

      toast.error("something went wrong");
    }
  };
  const refetchList = () => {
    getData();
  }

  const pageChangeHandler = (page) => {
    const newBody = {
      ...body,
      page,
      bookingTypeRequest: tab,
    };
    setBody((p) => newBody);
    getData(newBody);
  };

  useEffect(() => {
    getData(body);
  }, []);

  // const isStatusConfirmed = data?.map((item, index) => {
  //   const statusmain = item?.status;
  //   console.log(statusmain, "statchk");
  // });
  useEffect(() => {
    const newBody = {
      ...body,
      page: 1,
      bookingTypeRequest: tab,
    };

    setBody(newBody);
    getData(newBody);
  }, [tab]);


  const col = [
    {
      label: "Sr no",
      id: "srNo",
      isComponent: true,
      component: (_, key) => (
        <p className={` m-0`}>{(body.page - 1) * body.limit + (key + 1)}</p>
      ),
    },
    {
      label: "User Name",
      isComponent: true,
      component: (item, key) => (
        // <TableProfile url={item.customerImage} name={item.customerName} />
        <TableProfile
          url={item?.profileImage}
          name={item?.customerDetails?.name}
        />
      ),
    },
    {
      label: "Booking Id",
      id: "bookingNumber",
    },

    {
      label: "Mobile No",
      id: "bookingNumber",
      isComponent: true,
      component: (item) => (
        <p className="">
          {/* {item.providerCountryCode + item.providerMobileNumber} */}
          {item?.customerDetails.countryCode +
            item?.customerDetails.mobileNumber}
        </p>
      ),
    },
    {
      label: "location",
      id: "location",
      isComponent: true,
      component: (item) => <p className="fw-sbold">{item.pickUp.address}</p>,
    },
    {
      label: "Vehicle Type",
      id: "serviceType",
      classNames: "text-primary fw-sbold",
    },
    {
      label: "Vehicle Name",
      id: "vehicle",
      isComponent: true,
      component: (item) => <p className="fw-sbold">{item?.services}</p>,
    },
    {
      label: "Status",
      id: "status",
      isComponent: true,
      component: (item) => (
        // <p
        //   className={`fw-sbold m-0  ${
        //     item.status === "rejected"
        //       ? "text-danger"
        //       : item.status === "confirmed"
        //       ? "text-success"
        //       : "text-primary"
        //   }`}
        // >
        <p
          className={`${item.status === "rejected"
            ? "text-warning"
            : item.status === "confirmed"
              ? "text-primary"
              : "text-success"
            } m-0 fw-sbold `}
        >
          {item?.status.charAt(0).toUpperCase() + item?.status.slice(1)}
        </p>
      ),
    },
    {
      label: "View",
      isComponent: true,
      component: (item) => {
        const statusmain = item?.status;
        return (
          <div className="d-flex flex-column gap-2">
            <Link
              to={`/my-bookings/detail/${item._id}`}
              className="fw-sbold d-inline-flex align-items-center justify-content-center commonBtn  btn h-auto text-white w-50"
            >
              Details
            </Link>

            {/* <Link to="#"> */}
            {(statusmain === "confirmed" && !item?.driverId) && (
              <Button
                className="d-flex align-items-center justify-content-center commonBtn w-100 GreyBtn h-auto"
                type="button"
                onClick={() => handleAssignDriver(item?._id)}
                style={{ width: "auto" }}
              >
                Assign
              </Button>
            )}
            {/* </Link> */}
          </div>
        );
      },
    },
  ];
  return (
    <>
      <section className="bookingRequest py-5 position-relative">
        <Container>
          <Row>
            <Col lg="4" className="my-2">
              <Row className="justify-content-start">
                <Col lg="2" className="col-6 my-2">
                  {data?.status === "confirmed" && (
                    <Button
                      className="d-flex align-items-center justify-content-center commonBtn w-100 GreyBtn"
                      type="button"
                      onClick={handleAssignDriver}
                    >
                      Assign
                    </Button>
                  )}
                </Col>
              </Row>
              <Modal
                show={showModal}
                onHide={handleClose}
                size="lg"
                style={{ marginLeft: "45px", marginTop: "45px" }}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Assign Driver List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <GetAssignDriver
                    bookid={selectedBookingId}
                    setShowModal={setShowModal}
                    refetch={refetchList}
                  />
                </Modal.Body>
              </Modal>
            </Col>
            <Col lg="12" className="my-2">
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey="normal"
                onSelect={(e) => setTab(e)}
              >
                <Nav
                  variant="pills"
                  className="underlineTab border-bottom justify-content-center mb-3"
                  style={{ maxWidth: "max-content" }}
                >
                  <Nav.Item style={{ minWidth: 150 }}>
                    <Nav.Link
                      eventKey="normal"
                      className="bg-transparent position-relative fw-sbold text-center"
                    >
                      Standard
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item style={{ minWidth: 150 }}>
                    <Nav.Link
                      eventKey="bidding"
                      className="bg-transparent position-relative fw-sbold text-center"
                    >
                      Bidding
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <div className="table-responsive">
                  <Table data={data} column={col} loader={loader} />
                  <div className="d-flex align-items-center justify-content-end mt-2">
                    <div className="right">
                      <CustomPagination
                        total={totalCount}
                        pageSize={body.limit}
                        current={body.page}
                        pageChangeHandler={pageChangeHandler}
                      />
                    </div>
                  </div>
                </div>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default MyBookings;
